import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AgePipe } from './age/age.pipe';
import { BirthPipe } from './birth/birth.pipe';
import { CpfCnpjPipe } from './cpf-cnpj/cpf-cnpj.pipe';
import { DecimalShowPipe } from './decimal-show/decimal-show.pipe';
import { FilterSearchPipe } from './filter-search/filter-search.pipe';
import { LeafPathPipe } from './leaf-path-pipe/leaf-path.pipe';
import { ZipCodePipe } from './zipcode/zipcode.pipe';

const pipes = [
  AgePipe,
  BirthPipe,
  CpfCnpjPipe,
  DecimalShowPipe,
  FilterSearchPipe,
  LeafPathPipe,
  ZipCodePipe,
];

@NgModule({
  declarations: [...pipes],
  exports: [...pipes],
  imports: [CommonModule, IonicModule.forRoot()],
})
export class PipesModule {}
